import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ManagedAccountService } from './managed-account.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ManagedAccountInterceptor implements HttpInterceptor {
  constructor(private managedAccountService: ManagedAccountService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Get the current active managed account UUID
    const activeAccountUUID =
      this.managedAccountService.getCurrentActiveAccount();

    // If there is an active managed account and the request is going to the Benutzermanagement service,
    // add the ON_BEHALF_OF header – but never override an explicitly set header
    if (
      activeAccountUUID &&
      request.url.startsWith(environment.benutzermanagement) &&
      !request.headers.has('on-behalf-of-uuid')
    ) {
      // Clone the request and add the header
      request = request.clone({
        setHeaders: {
          'on-behalf-of-uuid': activeAccountUUID,
        },
      });
    }

    // Pass the modified request to the next handler
    return next.handle(request);
  }
}
